Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonStyles = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _airbnbWithTracking = require('airbnb-with-tracking');

var _airbnbWithTracking2 = _interopRequireDefault(_airbnbWithTracking);

var _removeFirefoxButtonPadding = require('../utils/removeFirefoxButtonPadding');

var _removeFirefoxButtonPadding2 = _interopRequireDefault(_removeFirefoxButtonPadding);

var _DOMButtonOrA = require('../private/DOMButtonOrA');

var _DOMButtonOrA2 = _interopRequireDefault(_DOMButtonOrA);

var _idProp = require('../utils/propTypes/idProp');

var _idProp2 = _interopRequireDefault(_idProp);

var _iconProp = require('../utils/propTypes/iconProp');

var _iconProp2 = _interopRequireDefault(_iconProp);

var _textlike = require('../utils/propTypes/textlike');

var _textlike2 = _interopRequireDefault(_textlike);

var _airmojiAdjacent = require('../utils/propTypes/airmojiAdjacent');

var _href = require('../utils/propTypes/href');

var _href2 = _interopRequireDefault(_href);

var _withStyles = require('../themes/withStyles');

var _withBrand = require('../themes/withBrand');

var _withBrand2 = _interopRequireDefault(_withBrand);

var _AccessibleText = require('./AccessibleText');

var _AccessibleText2 = _interopRequireDefault(_AccessibleText);

var _Loader = require('./Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _Labeled = require('./Labeled');

var _Labeled2 = _interopRequireDefault(_Labeled);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var GOLDEN_RATIO = (1 + Math.sqrt(5)) / 2;

var SHADOW_LEVELS = [0, 1, 2, 3];

var TYPES = {
  button: 'button',
  submit: 'submit'
};

var hierarchyLevel = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('primary', 'secondary', 'mono');
var blockProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('block', 'fullWidth', 'displayBlock');

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
  onPress: _propTypes2['default'].func,
  block: blockProps, // Legacy - do not use
  fullWidth: blockProps, // New version of "block" with old behavior
  displayBlock: blockProps, // "true" block behavior
  type: _propTypes2['default'].oneOf(Object.values(TYPES)),
  compact: _propTypes2['default'].bool,
  disabled: _propTypes2['default'].bool,
  loading: _propTypes2['default'].bool,
  children: (0, _airbnbPropTypes.or)([_airmojiAdjacent.textlikeAdjacentToAirmojiBefore, _airmojiAdjacent.textlikeAdjacentToAirmojiAfter, _textlike2['default']]),
  beforeIcon: _iconProp2['default'],
  afterIcon: _iconProp2['default'],
  inverse: _propTypes2['default'].bool,
  primary: hierarchyLevel,
  secondary: hierarchyLevel,
  mono: hierarchyLevel,
  href: _href2['default'],
  openInNewWindow: _propTypes2['default'].bool,
  small: _propTypes2['default'].bool,
  large: _propTypes2['default'].bool,
  rectangular: _propTypes2['default'].bool,
  ampVarsClickType: _propTypes2['default'].string,
  ampReplace: _propTypes2['default'].string,
  ariaHasPopup: _propTypes2['default'].bool,
  ariaDescribedBy: _idProp2['default'],
  noWrap: _propTypes2['default'].bool,
  buttonRef: _propTypes2['default'].func,
  velouteId: _propTypes2['default'].string,
  brand: _withBrand.requiredBrandPropType,
  hideText: _propTypes2['default'].bool,
  shadowLevel: _propTypes2['default'].oneOf(SHADOW_LEVELS)
}));

var defaultProps = {
  onPress: function () {
    function onPress() {}

    return onPress;
  }(),

  block: false,
  fullWidth: false,
  displayBlock: false,
  compact: false,
  type: TYPES.button,
  disabled: false,
  loading: false,
  inverse: false,
  primary: false,
  secondary: false,
  mono: false,
  openInNewWindow: false,
  small: false,
  large: false,
  rectangular: false,
  ampVarsClickType: undefined,
  ampReplace: undefined,
  ariaHasPopup: false,
  ariaDescribedBy: undefined,
  noWrap: false,
  buttonRef: function () {
    function buttonRef() {}

    return buttonRef;
  }(),

  velouteId: undefined,
  hideText: false,
  shadowLevel: 0
};

// Exported for testing
var buttonStyles = exports.buttonStyles = [
// Standard buttons
'primary', 'primarySmall', 'default', 'select', 'inverse',

// Secondary buttons
'secondary', 'selectSecondary', 'secondaryInverse', 'mono'];

function Button(_ref) {
  var css = _ref.css,
      block = _ref.block,
      fullWidth = _ref.fullWidth,
      displayBlock = _ref.displayBlock,
      children = _ref.children,
      compact = _ref.compact,
      beforeIcon = _ref.beforeIcon,
      afterIcon = _ref.afterIcon,
      onPress = _ref.onPress,
      type = _ref.type,
      disabled = _ref.disabled,
      loading = _ref.loading,
      inverse = _ref.inverse,
      primary = _ref.primary,
      secondary = _ref.secondary,
      mono = _ref.mono,
      href = _ref.href,
      openInNewWindow = _ref.openInNewWindow,
      small = _ref.small,
      large = _ref.large,
      rectangular = _ref.rectangular,
      ampVarsClickType = _ref.ampVarsClickType,
      ampReplace = _ref.ampReplace,
      ariaDescribedBy = _ref.ariaDescribedBy,
      ariaHasPopup = _ref.ariaHasPopup,
      noWrap = _ref.noWrap,
      buttonRef = _ref.buttonRef,
      styles = _ref.styles,
      velouteId = _ref.velouteId,
      brand = _ref.brand,
      hideText = _ref.hideText,
      shadowLevel = _ref.shadowLevel;

  var isSelectBrand = brand === _withBrand.BRAND_SELECT;
  var useLightLoader = !inverse && !mono && !secondary || secondary && inverse;
  var useDarkLoader = mono;

  var inner = void 0;
  if (beforeIcon) {
    inner = _react2['default'].createElement(
      _Labeled2['default'],
      {
        centered: true,
        before: _react2['default'].cloneElement(beforeIcon, {
          color: inverse ? beforeIcon.props.color : undefined,
          size: small ? 15 : 18
        }),
        spaceBetween: hideText ? 0 : 1.5
      },
      !hideText && children
    );
  } else if (afterIcon) {
    inner = _react2['default'].createElement(
      _Labeled2['default'],
      {
        centered: true,
        after: _react2['default'].cloneElement(afterIcon, {
          color: inverse ? afterIcon.props.color : undefined,
          size: small ? 15 : 18
        }),
        spaceBetween: hideText ? 0 : 1.5
      },
      !hideText && children
    );
  } else if (!hideText) {
    inner = children;
  }

  return _react2['default'].createElement(
    _DOMButtonOrA2['default'],
    _extends({
      disabled: disabled,
      onClick: onPress,
      type: type,
      href: href,
      openInNewWindow: openInNewWindow,
      ampVarsClickType: ampVarsClickType,
      ampReplace: ampReplace,
      ariaDescribedBy: ariaDescribedBy,
      ariaHasPopup: ariaHasPopup,
      buttonAnchorRef: buttonRef,
      velouteId: velouteId
    }, css.apply(undefined, [styles.container, !rectangular && styles.container_rounded, !rectangular && small && styles.container_roundedSmall, (block || fullWidth) && styles.container_fullWidth, displayBlock && styles.container_displayBlock,

    /* size and spacing styles */
    small ? styles.container_sizeSmall : styles.container_sizeRegular, large && styles.container_sizeLarge, compact && styles.container_sizeCompact,

    /* shadow styles */
    shadowLevel === 0 && styles.container_shadowLevel0, shadowLevel === 1 && styles.container_shadowLevel1, shadowLevel === 2 && styles.container_shadowLevel2, shadowLevel === 3 && styles.container_shadowLevel3].concat(_toConsumableArray(inverse && [styles.colors_inverse, secondary && styles.colors_secondaryInverse]), _toConsumableArray(!inverse && [styles.colors_default, primary && styles.colors_primary, isSelectBrand && styles.colors_select, secondary && styles.colors_secondary, secondary && isSelectBrand && styles.colors_selectSecondary, mono && styles.colors_mono]), [

    /* small button color styles */
    !inverse && small && primary && styles.colors_primarySmall]))),
    loading && _react2['default'].createElement(_Loader2['default'], { light: useLightLoader, dark: useDarkLoader }),
    loading && _react2['default'].createElement(
      _AccessibleText2['default'],
      null,
      inner
    ),
    _react2['default'].createElement(
      'span',
      css(styles.text, styles.text_sizeRegular, small && styles.text_sizeSmall, large && styles.text_sizeLarge, loading && styles.text_hidden, noWrap && styles.text_noWrap),
      inner
    )
  );
}

Button.componentCategory = 'Core';
Button.displayName = 'Button';
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
Button.TYPES = TYPES;

exports['default'] = (0, _withBrand2['default'])((0, _airbnbWithTracking2['default'])('Button', ['onPress'])((0, _withStyles.withStyles)(function (_ref2) {
  var border = _ref2.border,
      color = _ref2.color,
      font = _ref2.font,
      unit = _ref2.unit,
      spacing = _ref2.spacing,
      shadow = _ref2.shadow;

  var buttonColorStyles = {};

  buttonStyles.forEach(function (style) {
    var useWhiteFocusRing = style === 'secondaryInverse' || style === 'default' || style === 'select';

    buttonColorStyles['colors_' + String(style)] = Object.assign({
      background: color.buttons[String(style) + 'Color'],
      borderColor: color.buttons[String(style) + 'Border'],
      color: color.buttons[String(style) + 'Text'],

      ':hover': {
        background: color.buttons[String(style) + 'HoverColor'],
        borderColor: color.buttons[String(style) + 'HoverBorder'],
        color: color.buttons[String(style) + 'HoverText']
      },

      ':active': {
        background: color.buttons[String(style) + 'ActiveColor'],
        borderColor: color.buttons[String(style) + 'ActiveBorder'],
        color: color.buttons[String(style) + 'ActiveText']
      },

      ':disabled': {
        background: color.buttons[String(style) + 'DisabledColor'],
        borderColor: color.buttons[String(style) + 'DisabledBorder'],
        color: color.buttons[String(style) + 'DisabledText'],
        cursor: 'default'
      }

    }, (0, _removeFirefoxButtonPadding2['default'])({ inverse: useWhiteFocusRing }));
  });

  return Object.assign({
    container: Object.assign({
      cursor: 'pointer',
      display: 'inline-block',
      margin: 0,
      position: 'relative',
      textAlign: 'center',
      textDecoration: 'none',
      transitionProperty: 'background, border-color, color',
      transitionDuration: '0.2s',
      transitionTimingFunction: 'ease-out',
      width: 'auto'

    }, (0, _removeFirefoxButtonPadding2['default'])()),

    container_rounded: {
      borderRadius: border.button.borderRadius
    },

    container_roundedSmall: {
      borderRadius: border.buttonSmall.borderRadius
    },

    container_fullWidth: {
      width: '100%'
    },

    container_displayBlock: {
      display: 'block',
      width: '100%'
    },

    container_shadowLevel0: Object.assign({}, shadow.button.level0),

    container_shadowLevel1: Object.assign({}, shadow.button.level1),

    container_shadowLevel2: Object.assign({}, shadow.button.level2),

    container_shadowLevel3: Object.assign({}, shadow.button.level3),

    container_sizeRegular: Object.assign({}, font.button, font.bold, {

      borderWidth: border.button.borderWidth,
      borderStyle: 'solid',
      borderColor: color.clear,

      paddingLeft: spacing.button.horizontal,
      paddingRight: spacing.button.horizontal,
      paddingBottom: spacing.button.vertical,
      paddingTop: spacing.button.vertical,
      minWidth: GOLDEN_RATIO * 2 * spacing.button.horizontal
    }),

    container_sizeSmall: Object.assign({}, font.buttonSmall, font.book, {

      borderWidth: border.buttonSmall.borderWidth,
      borderStyle: 'solid',
      borderColor: color.clear,

      paddingLeft: spacing.buttonSmall.horizontal,
      paddingRight: spacing.buttonSmall.horizontal,
      paddingBottom: spacing.buttonSmall.vertical,
      paddingTop: spacing.buttonSmall.vertical,
      minWidth: GOLDEN_RATIO * 2 * spacing.buttonSmall.horizontal
    }),

    container_sizeLarge: Object.assign({}, font.bold, {
      paddingLeft: spacing.buttonLarge.horizontal,
      paddingRight: spacing.buttonLarge.horizontal,
      paddingBottom: spacing.buttonLarge.vertical,
      paddingTop: spacing.buttonLarge.vertical,
      minWidth: GOLDEN_RATIO * 2 * spacing.buttonLarge.horizontal
    }),

    container_sizeCompact: {
      paddingRight: unit,
      paddingLeft: unit
    }

  }, buttonColorStyles, {

    text: {
      color: 'inherit'
    },

    text_hidden: {
      visibility: 'hidden'
    },

    text_noWrap: {
      whiteSpace: 'nowrap'
    },

    text_sizeRegular: Object.assign({}, font.button, {
      color: 'inherit'
    }),

    text_sizeSmall: Object.assign({}, font.buttonSmall, {
      color: 'inherit'
    }),

    text_sizeLarge: Object.assign({}, font.textLarge, {
      color: 'inherit'
    })
  });
})(Button)));


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/Button.js
// module id = 73
// module chunks = 168707334958949